import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Text, Icon } from '@atomic';
import { COLOR_FONT_GRAY } from '@assets/color';
import { MediaQueries, BREAKPOINT_PHONE } from '@style/MediaQuery';
import FoldIcon from '@assets/icon/icn_arrow_left.svg';

const CommentCountMenu = styled.div`
  display: flex;
  color: ${COLOR_FONT_GRAY};
  margin: 7px 0 14px 0;
  align-items: center;

  ${MediaQueries(BREAKPOINT_PHONE)} {
    display: none;
  }
`;

const iconStyle = (isFold) => {
  const computedTransform = isFold ? 'rotate(-90deg)' : 'rotate(90deg)';

  return {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    transform: computedTransform,
  };
};

function PostCommentCounter({ isFold, commentCount, handleFold, ...props }) {
  return (
    <CommentCountMenu {...props}>
      <Text>댓글 {commentCount}개</Text>
      <Icon
        src={FoldIcon}
        clickable
        iconSize={15}
        onClick={handleFold}
        style={iconStyle(isFold)}
      />
    </CommentCountMenu>
  );
}

PostCommentCounter.propTypes = {
  isFold: PropTypes.bool,
  commentCount: PropTypes.number,
  handleFold: PropTypes.func,
};

export default PostCommentCounter;
